import { render } from "./FinishRegistration.vue?vue&type=template&id=e56b73e2"
import script from "./FinishRegistration.vue?vue&type=script&lang=js"
export * from "./FinishRegistration.vue?vue&type=script&lang=js"
script.render = render

export default script